export default {
    menu: {
        home: '首页 ',
        blockBrowser: '区块链浏览器',
        internetCourt: '互联网法院',
        validateQuery: '查询验证',
        evidenceExtraction: '证据提取',
        solution: "解决方案",
        alliance: "分布式应用",
        whitePaper: "技术白皮书",
        activityProduct: "联盟动态",
        contactUs: "联系我们",
        openPlatform: "开放平台",
    },
    index: {
        banner01: {
            title: '构建数字世界文明秩序',
            content: '以技术驱动，专注于电子数据主权确定及网络行为分析，以构建数字世界的文明秩序为愿景，依托云计算、人工智能、区块链、大数据、深度学习等技术进行计算法律学实践',
        },
        banner02: {
            title: '面向法律领域的司法联盟链',
            content: '多方共建联盟链，法律效力共同见证，安全可靠，数据永不丢失，自主可控联盟区块链技术',
        },
        banner03: {
            title: '建设司法界通用的区块链底层基础设施',
            content: '打造统一、标准、可靠的司法界数据存证平台',
        },
        // 技术演进
        Technology: '技术演进',
        TechnologyBlock1: "legalXchain是基于legalFabric框架和要求开放的司法联盟链，主要链接司法机关、法律科技应用、数据主权企业等。",
        TechnologyBlock2: "legalFabric针对政务、法律、监管等业务场景安全性、业务性能、业务承载、数据访问机制等方面加以改进和提升技术架构。",
        TechnologyBlock3: "超级账本是Linux基金会下的全球开放的联盟链组织。包括华为、IBM、百度等均为超级账本成员，真相科技为超级账本成员。",
        TechnologyBlock3Title: "超级账本",

        //联盟节点成员
        node: '联盟节点成员',
        LegalTech: "法律科技应用",
        RegTech: "监管科技应用",
        NotarialOffice: "公证机构",
        LawEnforcement: "执法机构",
        ppc: '公、检、法机构',
        Administration: "行政监管机构",
        JudicialExpertise: "司法鉴定机构",
        Enterprises: "企业与社会组织",

        //司法联盟链生态
        LegalxchainEcolog: "司法联盟链生态",
        LegalxchainEcologDscp: "基于legalXchain的区块链网络可以将司法机构作为区块链接点，并通过区块链分布式应用赋能司法机构的信息系统，使司法机构的信 息系统具备 legalXchain所具有的特性，这些特性包括数据的按需流转、数据的可追溯以及区块链分布式应用所具备的大数据、云计算和 AI 方面的能力，可以有效提升司法机构的信息服务能力及司法协同效率。",
        Architecture: "体系结构",
        ArchitectureDscp: "区块链技术在数据加密和不可篡改性等方面的技术特征，和电子证据技术密切相关，传统意义上的电子证 据技术同样需要保证数据的原始性和完整性，区块链技术的加密和链式结构在上链后数据的完整性和不可篡改性可以无缝应用到电子证据领域。legalXchain在数据加密方面的优势以及多通道业务机制、分布式 数据网关系统，尤其适合在电子证据平台领域中的应用。",

        //联盟链实战场景
        ActualCombat: "联盟链实战场景",
        ActualBlock1: {
            title: '法院',
            item1: '法院直接调取DAPP的电子证据',
            item2: "调取电子证书和司法鉴定证书",
            item3: "审判过程文书存档"
        },
        ActualBlock2: {
            title: '司法鉴定机构',
            item1: '区块链同步数字指纹，监督节点',
            item2: "调取DAPP的电子数据或电子证据",
            item3: "对数据进行司法鉴定"
        },
        ActualBlock3: {
            title: '公证处',
            item1: '区块链同步数字指纹',
            item2: "监督节点、业务节点",
            item3: "电子公证或在线公证"
        },
        ActualBlock4: {
            title: '真相科技IP360',
            item1: 'legalXchain分布式应用',
            item2: "联盟链节点快速部署应用节点"
        },
        siteLinks: "友情链接"


    },
    blockChain: {
        banner01: {
            title: '建设司法界通用的区块链底层基础设施',
            content: '以真相科技自主研发的</br>底层区块链平台legalFabric为依托，</br>打造统一、标准、可靠的司法界数据存证平台',
        },
        blockOverview:'legalXchain司法联盟链总览',
        blockHeight: "区块高度",
        nodeNumber: "节点数",
        tradingCapacity: "交易数量",
        blockHeightOverview:'区块总高度',
        nodeNumberOverview:'节点总数',
        tradingCapacityOverview:'交易总数量',
        netState: "网络状态",
        netStatePendding: "运行中",
        preservationTime: "存证时间",
        preservationID: "存证ID",
        node: '节点信息',
        transactionTime: '交易时间',
        transactionId: '交易ID',
        subject: '用户主体',
        hash: "区块hash",

        networkState: {
            title: '区块链网络状态',
            status1: '运行中',
            status2: '升级中',
            status3: '告警中',
            nodesTitle: '区块链节点'
        },

        legalXchainDscp: "联盟链介绍",

        legalXchainDscpBlock1: {
            title: '降低司法成本',
            content: "legalXchain联盟链的合约记录在账本上。无论事件有任何争议，合约都被看作是强有力的证据，并具有法律约束力。以往案件中争议焦点和审查难点（如电子证据的真实性、客观性，以及平台的中立性等问题），也有望在新技术的应用下得到有效缓解，从而降低了司法服务的综合成本。",
        },
        legalXchainDscpBlock2: {
            title: '打破数据孤岛',
            content: "区块链上所有数据，都可以根据一定的规则，允许相关的节点成员以某种授权的方式进行访问，基于legalXchain联盟链访问控制机制，数据所有者可以设置哪些人能看，哪些人不能看，以实现不同的人看到不同数据，由此，既实现了数据共享，又可以明确所有权归属。",
        },
        legalXchainDscpBlock3: {
            title: '提升维权效率',
            content: "legalXchain联盟链的开放性可以让任何机构或个人，在任意时间或地点向区块链写入信息，并将数据保存到不可篡改的分布式账本中，且永不丢失；避免了中心化服务所存在的宕机风险。维权难所反映的效率低下的本质也已经面临改变，传统司法服务中的电子数据验证，核查等环节将变得多余，维权效率由此可获得大幅提升。",
        },
        legalXchainDscpBlock4: {
            title: '引领司法服务转型升级',
            content: "新技术的应用，总是最先有了基础设施，而后扩展到一般性业务。在不久的将来，将会产生更多的新业务运行在legalXchain联盟链上，希望他能普惠到司法服务的更多业务场景中。以此为契机，司法服务机构可以据此建立新的服务标准，以市场和用户为导向，变革自己的商业模式，推动自身乃至整个行业良性发展。",
        },
        legalXchainDscpBlock5: {
            title: '提高全社会契约执行效率',
            content: "legalXchain联盟链中所具有的智能合约是以机器自动的方式，将义务和权利的关系以程序的形式表达出来。智能合约就是一个程序，它以计算机指令的方式实现了传统合约的自动化处理，将保障协议以自动、正确的方式执行，确保交易的有效性和执行性。从而实现执行成本的大幅降低，减少司法纠纷，提升社会的契约执行效率。",
        },
        goodnessBlock: '区块链优势',
        goodnessBlockItem1: "数据信息可信、数据安全流转",
        goodnessBlockItem2: "跨机构，跨部门实现信息“链接”",
        goodnessBlockItem3: "无缝对接，屏蔽数据孤岛，重构数据层",
        goodnessBlockItem4: "不依赖于当前复杂网络重构网络层",
        enterQueryId: "请输入交易ID查询",
        queryId: "交易ID",
        LatestPreservationRecord: '最近存证记录',
        BlockchainRecord: "区块链记录"
    },
    // 互联网法院
    internetCourt: {
        procedure: {
            title: '司法联盟链分布式应用证据流转互联网法院流程',
            tabsControl: ['北京互联网法院', '杭州互联网法院诉讼平台', '广州互联网法院'],
            language: 'cn',
            downloadTitle: '帮助文档下载'
        },
        fastEntry: {
            title: '互联网法院快捷入口',
            itemTitle: ['北京互联网法院诉讼平台', '杭州互联网法院诉讼平台', '广州互联网法院诉讼平台'],
            login: '用户登录',
            register: '用户注册',
            fastPreview: '电子诉讼平台案件受理范围快速预览 | 诉讼指引',
            serves: ['开庭公告', '文书公开', '庭审公开', '诉讼指南', '诉费计算', '下载中心', "暂无内容"],
            language: 'cn'
        }
    },
    // 查询验证
    validateQuery: {
        tabTitle: [
            "证书查询",
            "电子数据保全验证",
            "北京互联网法院存证查询",
            "广州互联网法院存证查询",
            "杭州互联网法院诉讼平台存证查询"
        ],
        tab_1: {
            title_certHash: '证书编号或证书SHA512摘要',
            holder_certHash: '请输入证书编号或证书SHA512摘要',
            void_certHash: '请输入证书编号或证书SHA512摘要',
            title_2: '证件号码',
            holder_2: '个人实名请输入身份证号，企业实名请输入营业执照号',
            void_2: '证件号码不可为空',
            title_vCode: '验证码',
            holder_vCode: '请输入验证码',
            void_vCode: '验证码不可为空',
            change_vCode: '看不清，换一张',
            err: '输入格式有误，请重新输入',
            err_2: "验证码错误，请重新输入",
            search: '查 &nbsp;&nbsp;&nbsp;&nbsp; 询',
            continue: '继续查询',
            errTips: '非常抱歉，证书不存在：该文件未经过【电子证据保管平台】进行保全。',
            deleteTips:'非常抱歉，证据已被删除，暂不支持查询！',
            expireTips:'非常抱歉，证据已过期，暂不支持查询！',
            notSupport:'证据已保全，但尚未出证书，需要出证后才能查验。'
        },
        tab_2: {
            title_1: '电子数据',
            holder_1: '请选择文件',
            void_1: '请选择文件',
            operate: '选择文件',
            enclosure_title: '此文件为附件',
            title_2: '用户名',
            holder_2: '请输入用户名',
            void_2: '用户名不可为空',
            title_vCode: '验证码',
            err_2: "用户不存在",
            err_3: "验证码不正确",
            holder_vCode: '请输入验证码',
            void_vCode: '验证码不可为空',
            change_vCode: '看不清，换一张',
            err: '请上传正确格式',
            reminder: '* 温馨提示：电子数据需自保全后未被修改才能通过验证',
            search: '验 &nbsp;&nbsp;&nbsp;&nbsp; 证',
            continue: '继续验证',
            err_4: "文件上传失败",
            err_6: "文件过大，超出上传范围",
            err_5: "输入格式有误，请重新输入",
            errTips: '非常抱歉，电子数据保全验证失败：该文件未经过【电子证据保管平台】进行保全。',
            deleteTips:'非常抱歉，证据已被删除，暂不支持查询！',
            expireTips:'非常抱歉，证据已过期，暂不支持查询！'
        },
        tab_3: {
            title_1: '证书编号或证据包提取码',
            holder_1: '请输入证书编号或证据包提取码',
            void_1: '证书编号或证据包提取码不可为空',
            title_vCode: '验证码',
            holder_vCode: '请输入验证码',
            void_vCode: '验证码不可为空',
            change_vCode: '看不清，换一张',
            err: '输入格式有误，请重新输入',
            search: '查询',
            download: '生成诉讼平台证据包',
            tableHeader_1: '序号',
            tableHeader_2: '司法联盟链保全ID',
            tableHeader_3: '北京互联网法院存证编号',
            errCode: "未查询到相关数据",
            err_3: "验证码错误",
        },
        tab_4: {
            title_1: '证书编号或证据包提取码',
            holder_1: '请输入证书编号或证据包提取码',
            void_1: '证书编号或证据包提取码不可为空',
            title_vCode: '验证码',
            holder_vCode: '请输入验证码',
            void_vCode: '验证码不可为空',
            change_vCode: '看不清，换一张',
            err: '输入格式有误，请重新输入',
            search: '查询',
            tableHeader_1: '序号',
            tableHeader_2: '司法联盟链保全ID',
            tableHeader_3: '广州互联网法院存证编号',
            errCode: "未查询到相关数据",
            err_3: "验证码错误",
        },
        tab_5: {
            title_1: '证书编号或证据包提取码',
            holder_1: '请输入证书编号或证据包提取码',
            void_1: '证书编号或证据包提取码不可为空',
            title_vCode: '验证码',
            holder_vCode: '请输入验证码',
            void_vCode: '验证码不可为空',
            change_vCode: '看不清，换一张',
            err: '输入格式有误，请重新输入',
            search: '查询',
            tableHeader_1: '序号',
            tableHeader_2: '司法联盟链保全ID',
            tableHeader_3: '杭州互联网法院诉讼平台存证编号',
            errCode: "未查询到相关数据",
            err_3: "验证码错误",
            desc_text: "杭州互联网法院诉讼平台提供证据导入查验同步功能，请直接在诉讼平台输入证据证书编号完成查询验证和导入。",
            buttonText: '返回'
        },
        noRealTip: '非常抱歉，此功能只有实名认证用户才能使用，您暂未实名，请进行实名认证。',
        iKnow: '我知道了'
    },
    // 证据提取
    evidenceExtraction: {
        speed: '快捷  安全  高效',
        towen: '在没有证据形成意见的时候硬要造成一种意见，是没有意义的。\
		<br />倘使你造一个没有骨头的人，一眼看上去也许栩栩如生，\
		<br />可是软绵绵地站不起来；……证据是意见的骨头。\
		<br />\
		<br />— 马克 · 吐温',
        areaTitle: '证据提取',
        input_1: '请输入证据提取码',
        input_2: '请输入验证码',
        err_2: "输入格式有误,请重新输入",
        void_vCode: '验证码不可为空',
        err_3: "验证码不正确",
        err_4: "证据提取码不存在",
        err_5: "证据提取码已失效",
        search: '提 取'
    },
    solution: {
        banner01: {
            title: '世界领先的电子证据平台方案',
            content: '实时搜索引擎、自动取证，跨部门证据交换，多维度证据检索，区块链＋法律可信云计算',
        },
        JudicialSolutions: {
            title: "赋能司法解决方案",
            item1: "提升维权效率，破解司法服务效率低下的问题",
            item2: "实现司法数据的融合共享，打破数据孤岛",
            item3: "推动社会信用体系建设，降低司法成本",
            item4: "以技术为引擎，推动创新发展，引领司法服务转型升级",
            item5: "减少司法纠纷，提高全社会契约执行效率",
        },
        CooperativeSolution: {
            title: "政务协同解决方案",
            item1: "打破传统政务信息系统数据孤岛的壁垒",
            item2: "解决传统政务信息系统协同、流转困难的痛点",
            item3: "提供高效有序，可追溯的，不可篡改，自动流转的政务信息协同服务",
            item4: "消除政务机构信息流转隐形成本"
        },
        AttributionSolution: {
            title: "行业级数据权益解决方案",
            item1: "解决垂直行业关联数据权益流转",
            item2: "基于智能合约的全流程权益交易",
            item3: "基于区块链的上下游可信协同",
            item4: "打破行业内不同机构的信息壁垒"
        },
        DistributedApplication: {
            title: "DAPP分布式应用",
            item1: "司法联盟链赋强孤立的信息系统，提升单点业务系统服务能力",
            item2: "使信息系统生态化，提升信息系统生命力与生态服务能力",
            item3: "基于区块链安全机制的数据协同、功能协同、业务协同",
            item4: "数据流、功能流、业务协同流可追溯",
        }
    },
    technology: {
        banner01: {
            title: 'legalXchain技术白皮书',
            content: 'legalXchain区块链构建起法律、监管、政务的底层基础设施，并在数据与资产确权、法律责任界定、契约的代码化与智能执行方面发挥维护数字世界法律规则与实现的基础作用',
        },
        AdviserExpert: "顾问专家",
        FamousInvestor: '著名投资人',
        FamousInvestorDscp: "现为北京青普旅游文化发展有限公司董事长。曾任万通集团董事局副主席、美国万通集团董事长、鼎晖投资创始合伙人、IDG高级合伙人，曾主导投资易趣、奇虎360、3721、民生银行、亚信集团、展讯科技等。",
        FamousLegalResearch: "著名法学研究专家",
        FamousLegalResearchDscp: "现任中国廉政法制研究会会长。曾任司法部律师司干部，办公厅秘书，《中国律师》杂志社总编辑，全国 律协党组成员，司法部司法研究所副所长，中国法学会研究部主任，中国廉政法制研究会常务副会长。",
        BlockChainChipExper: "区块链芯片专家",
        BlockChainChipExperDscp: "区块链软件和芯片研发专家，拥有20年以上的研发经验。他在区块链、大数据平台、物联网平台和操作系统核心等领域均有世界领先的技术成果和丰富的产品技术实战经验，并拥有近10项相关领域发明专利。",
        ArticlePart1: "区块链技术的核心作用在于通过计算机技术重构生产关系，这项技术发明和以往的所有科学技术发明不同的是，区块链技术将生产关系通过代码和合约来实现，区块链技术是信任机器，从某种意义上说，区块链用简 单的程序语言将人际社会最复杂的信任关系问题转化成了人人可见的代码，使一切行为和过程可追溯、可共识。 因此，区块链技术是一项非同一般的发明创造。",
        ArticlePart2: "区块链技术的特点尤其适合数字世界，世界的数字化将是不可逆的，未来的人类社会将是一个几乎可以通 过数字进行直观呈现和展示的世界。当数字化进展到当前阶段，解决数字世界的经济关系问题逐渐有人为主体 向机器规则主体迁移。因此，数字世界的文明秩序得以通过计算机技术更好的实现，也是人类社会文明高度的 体现。",
        ArticlePart3: "真相科技的使命即是构建数字世界文明秩序，区块链技术是构建数字世界文明秩序的基础存储和计算网络， 得益于计算机行业的共同努力，真相科技继承超级账本 Fabric 开源项目，研究开发了适用于社会文明秩序构建 的技术框架 Legal Fabric，并以 Legal Fabric 为技术原则，开发并大规模应用 legalXchain 区块链系统，用以铺设数字世界的底层文明秩序规则，是区块链技术推进社会文明进程的前沿和成熟实践。相信在 legalXchain 区块链系统的帮助下，我们会迎接一个更文明的数字世界。",
        next: "下一页",
        pre: "上一页",
        download: '下载'
    },
    news: {
        banner01: {
            title: '联盟动态',
            content: '汇聚legalXchain成员旗下动态',
        },
        newsBlockOne: {
            title: '最新动态',
        },
        newsBlockTwo: {
            title: '动态列表',
        },
        details: '详情',
        paging: {
            next: '下一篇',
            previous: '上一篇'
        },
        updated: '发布时间',
        newsDetailTitle: '联盟详情'
    },
    ContactUs: {
        ContactUs: '联系我们',
        tailWe: "给我们留言",
        ContactInformation: "联系方式",
        SchemeCounseling: "方案咨询",
        Tel: '电话：',
        Email: '电子邮箱',
        clickEnter: "点击进入",
        Telplaceholder: '电话',
        name: '姓名',
        pleaseEnter: "咨询或建议"
    },
    footer: {
        OfficialWebsite: '官网：',
        SDKContact: 'SDK接入：',
        JoinUs: '加入我们：',
        copy: "版权所有：真相网络科技（北京）有限公司"
    },
    // 开放平台
    openPlatform: {
        title: [
            '对接模式', '接入流程', '技术能力', '产品能力', '开放平台', '解决方案',
            'legalXchain开放平台', '平台优势'
        ],
        bannerContent: '构建数字世界文明秩序<br/>面向法律领域的司法联盟链<br/>建设司法界通用的区块链底层基础设施',
        indexContent: {
            more: '了解更多'
        },
        infoList: [
            '基于Legal Fabric具有自主知识产权的区块链网络',
            '超级账本全球六大区块链典型案例之一',
            '工信部区块链白皮书司法领域典型案例',
            '全国首个区块链网络赋强公证系统',
            '全国首个区块链公证分布式应用',
            '北京地区首个区块链电子证据司法判例',
            '全国首个区块链智慧监狱系统',
            '北京、广州、杭州三大互联网法院区块链系统首批接入方'
        ],
        dockingModeHeaders: [
            '通过成为legalXchain节点接入',
            '通过分布式应用的PaaS接入',
            '通过跨链机制接入legalXchain'
        ],
        dockingModeContent: [
            [
                '自主运用司法联盟链legalXchain的所有基础功能和特性',
                '灵活的二次开发支持和BaaS服务',
                '快速部署区块链节点、迅速获取全国司法联通性'
            ],
            [
                '覆盖政务、版权、金融、行政执法、存取证、元宇宙等各类应用接口',
                '按需匹配最优区块链应用平台支撑自身业务',
                '即插即用的各类API接口覆盖身份验证、时钟系统、业务功能API等'
            ],
            [
                '支持异构区块链、私有区块链网络的跨链接入',
                '极大保障私有区块链的自主可控及业务安全性',
                '各行业区块链应用方案支持合作伙伴建设私域或公域区块链网络'
            ]
        ],
        flowName: [
            ['申请接入', '资格审核', '方案设计', '合作签署', '开发上线'],
            ['选择节点', '申请接入', '获取SDK', '测试联调', '上线'],
            ['方案咨询', '方案沟通', '合作框架协议', '沟通确认解决方案', '正式合作签署协议', '建设、部署、实施'],
        ],
        flowContent: [
            [
                '联系我们，表达合作意向，申请接入',
                '成为区块链节点需要满足相关资质要求，以保障区块链网络的安全性及合规性',
                '基于应用场景建设符合合作伙伴业务的分布式应用系统',
                '签署相关合作协议',
                '按对接方案开发，测试，联调，申请上线',

            ],
            [
                '选择适合的分布式应用平<br/>台作为PaaS接入',
                '联系我们，表达合作意<br/>向，申请接入',
                '申请审核通过后，获取业<br/>务开发所需SDK',
                '开发完成后，测试环境进<br/>行联调',
                '测试环境联调通过后，申<br/>请上线'
            ]
        ],
        technicalCapacity: [
            {name: '大数据', text: '大量 高速 多样', desc: '真相科技强大的数据挖掘、清洗、分析能力，对复杂的互联网动态数据和静态数据进行高并发的数据处理，以支持各类复杂的业务应用场景。'},
            {name: '云计算', text: '高效 迅捷 按需扩充', desc: '弹性云计算技术，按需扩展计算能力，无缝满足业务对计算能力的要求；系统采用分布式计算结构，分布式处理、分布式数据库、数据库分层等技术。'},
            {name: '区块链', text: '弹性节点部署 开放共融', desc: '依托完全自主知识产权的区块链技术，构建可弹性自动部署节点的司法级区块链联盟链，是区块链在法律科技领域的有效落地和应用。'},
            {name: 'AI（人工智能）', text: '内容识别 内容认知', desc: '真相科技综合性运用自然语言处理、图像识别、视频比对、音视图文语义理解等技术，实现各类数据内容的精准发现、识别以及对内容的感知。'},
            {name: 'NLP（自然语言处理）', text: '情感分析 语义理解', desc: ' 真相科技将自主研发的NLP技术应用到对音视图文信息的情感分析与语义理解，通过深度学习算法，自动智能判断内容的情感属性，是平台内容审核过滤的利器。'},
            {name: '法律科技', text: '法律有效性 技术先进性', desc: '真相科技在法律有效性的框架内成功的将大数据、AI、云计算、区块链等前沿技术，用于提升数字世界的司法运行效率，保障数字世界的合规性、合法性。'},
            {name: '垂直搜索技术', text: '专业 全面 快速', desc: '真相科技研发了业内首款证据发现搜索引擎，深度应用垂直搜索技术，是e-discovery业务在国内的成功实践。'},
            {name: '区块链智能合约', text: '智能 安全 防篡改', desc: '区块链智能合约，将业务规则抽象为数字化合约，嵌入blockchain执行，并且可以被校验；能保证每一步严格按事先设计的流程进行，避免争议风险。'},
            {name: '弹性节点部署', text: '灵活 可扩展', desc: '区块链节点可以按照客户的要求实现客户本地部署，也可以云平台托管部署。'},
            {name: '图像识别', text: '智能 应用广泛', desc: ' IP360图片监测应用人工智能图像识别技术，通过对图像进行处理、分析和理解，能够精准的打击图片、商标等图像侵权行为。'},
            {name: '弹性可信云计算', text: '横向 可扩展', desc: ' IP360可信云取证系统在遇到大量取证需求时，可以进行横向扩展，支持大并发任务及大数据量的处理。'},
        ],
        productContent: [
            {name: '确权', text: '文件确权 脱敏确权 网页确权'},
            {name: '签名', text: '数字签名 智能合约 履约管理 合同管理'},
            {name: '数据存证', text: '原数据存证 脱敏存证 关联存证'},
            {name: '监测', text: '文字监测 图片监测 音频监测 视频监测 舆情监测 电商监测 商标监测'},
            {name: '安全', text: '大陆身份核验 海外身份核验 域外取证'},
            {name: '取证', text: '快照取证 录屏取证 过程取证 移动端取证 手机阵列'},
            {name: '司法能力', text: '在线公证 在线司法核验 在线诉讼 在线法律服务'},
            {name: '更多能力敬请期待'},
        ],
        solution: {
            headers: ['政府级解决方案', '企业级解决方案', '区块链+解决方案'],
            contentHeaders: [['执法需求', 'IP360方案介绍'], ['行业痛点', 'IP360方案介绍'], ['市场需求', '解决方案']],
            desc: '端到端行业及产业级数据法治解决方案',
            content: [
                [{
                    type: '知识产权局',
                    imgUrl: '/images/pc/v2/home/solutions/zscqj.png',
                    pain: ['在高新技术迅猛发展的环境下，互联网知识产权侵权呈现出群体性、规模性的新特点，原有的知识产权行政执法方式日益捉襟见肘，难以适应当下知识产权高标准、高水平的保护，急需有效的技术手段来完成对互联网新业态新领域和民生领域的知识产权保护工作。'],
                    solution: ['针对知识产权领域的各种侵权行为，提供自动化监测和取证功能，高效便捷地将监管内容固化形成具备司法效力的电子证据。协助知识产权局进一步加强互联网新业态新领域和民生领域的知识产权保护工作，提升知识产权保护社会满意度。']
                }, {
                    type: '环境保护局',
                    imgUrl: '/images/pc/v2/home/solutions/hjbhj.png',
                    pain: ['当前我国环境保护问题频出，环保部门收集证据往往是在线下，收集证据一直是环保部门办理案件的一个瓶颈。需要充分发挥社会的力量，发动公益组织和个人提供违法行为，收集环境污染证据，并反馈给环保部门。'],
                    solution: ['IP360移动端为各类用户提供取证服务，不受地域限制。移动端可以对各种环境污染现象以拍照、摄像、GPS定位等方式进行有效取证，方便快捷的对环境污染问题进行取证和举报。']
                }, {
                    type: '交通管理局',
                    imgUrl: '/images/pc/v2/home/solutions/jtglj.png',
                    pain: ['各类交通事故和违法行为越来越多，给交管部门的工作带来了很大的压力。当出现轻微机动车交通事故时，需要有效方法尽量缩短占路时间，减轻因事故造成的道路拥堵程度。另外对于交通违法行为，也需要借助广大人民群众的力量，为交管部门提供交通执法线索和依据，及时发现和处理出现的交通违法行为。'],
                    solution: ['出现交通事故时，交警可以通过移动端进行取证，包括图片、视频、时间地点等信息，现场进行处理，提取证据更简单高效。事故双方也可以自行进行现场的取证，快速处理交通事故，降低道路拥堵风险，减少对交通的影响。']
                }, {
                    type: '工商行政管理局',
                    imgUrl: '/images/pc/v2/home/solutions/gsxzglj.png',
                    pain: ['当前我国电商、网上营销等产业发展迅猛，例如淘宝电商、微信营销，但是假冒伪劣产品也随之而来。如何规范网络购物行为，以及处理网络购物带来的各种纠纷，成为工商管理部门面临的新问题。'],
                    solution: ['IP360平台针对各大购物网站、APP及其他线上购物方式，提供电商监测能力。对假冒伪劣、虚假促销、价格欺诈等违法行为，进行预警、证据提取和固化，为工商部门提供监管平台和执法依据，辅助工商管理部门建设绿色的互联网营销环境。']
                }, {
                    type: '新闻出版广电局',
                    imgUrl: '/images/pc/v2/home/solutions/xwcbgdj.png',
                    pain: ['由于网络的虚拟性、开放性、隐蔽性等特征，新闻出版广电局在对互联网数字出版内容活动、网络视听节目的监管过程中，面临着网络行为三难：发现难，取证难，监管难。'],
                    solution: ['IP360平台可以针对互联网上的数字出版内容和网络视听内容进行实时监测，在海量互联网数据中及时发现违法行为，高效固化形成具备司法效力的电子证据，协助新闻出版广电局完成对互联网数字出版内容活动、网络视听节目的监管工作。']
                }, {
                    type: '城市管理行政执法局',
                    imgUrl: '/images/pc/v2/home/solutions/csglxzzfj.png',
                    pain: ['城管人员在执法过程中，“暴力执法”和“被暴力”的事件时有发生。证明执法行为规范有效，同时又能保护执法人员自身权益不受侵害，保存第一手的执法证据材料就显得尤为重要。而在某些执法场景中，传统的执法记录仪无法满足实际执法的要求，需要有更加方便快捷的工具随时随地来完成证据材料的记录。'],
                    solution: ['在城管人员执法过程中，通过使用IP360移动端取证APP，可以记录执法现场的声音、图像，时间地点信息，保存执法现场证据材料，使执法过程公开公正透明，提高执法的公信力度，同时保护执法人员自身权益不受侵害。防范暴力执法和被暴力的事件发生，确保执法过程公开透明，提高执法公信力度。']
                }, {
                    type: '智慧城市',
                    imgUrl: '/images/pc/v2/home/solutions/zhcsjjfa.png',
                    pain: ['智慧城市建设涉及多个领域的建设，包括金融、医疗、法律、交通、监管、环保、监督等。不同行业的电子数据需要存证，违法证据也需要取证，部分需要现场进行取证。同时发动公益组织和个人参与到城市的执法中，积极提供违法证据。'],
                    solution: ['为智慧城市整体建设，提供各类数据的存证，确保数据有效，避免各类隐患。', '为各级执法部门和监管部门提供有效的监管手段和证据提取手段，提升执法效率。', '整合公益组织和热心群众的力量，发挥社会的力量，共同建设智慧城市。']
                }], [{
                    type: '企业数据主权保护',
                    imgUrl: '/images/pc/v2/home/solutions/qysjzqbhjjfa.png',
                    pain: ['企业日常经营产生大量具有产权的数据，这类数据也代表了商业价值。', '企业数据碎片化、分散化、易流动，很难管理。', '企业数据被窃取，极易导致经营损失。', '很难保证企业数据的法律效力。'],
                    solution: ['通过确权系统，企业自主对内部数据进行确权，使之具有法律效力。', '通过云监测系统，监测企业数据是否流入互联网。', '对各分支机构的数据进行集中管理，控制风险。', '通过一站式方案，对于数据侵权行为进行取证和司法打击。']
                }, {
                    type: '品牌保护',
                    imgUrl: '/images/pc/v2/home/solutions/ppbhjjfa.png',
                    pain: ['网络上商标侵权，外观设计侵权等侵权行为泛滥，且屡禁不止。', '假冒伪劣是网络上最常见的侵权行为。', '企业难于发现侵权行为，发现时已经泛滥成灾。', '取证的手续复杂，效率不高，且后续维权成本高昂。', '对于负面舆情，难于监管，难于引导。'],
                    solution: ['未取得知识产权的资产，可自主进行确权，具有法律效力。', '对侵权行为全网监测，做到早发现，早处理，控制损失。', '一站式的侵权取证和维权服务，保证维权的高效，成本低。', '专业的舆情服务，负面舆情预警和公关，做企业的舆情管家。', '一站式的品牌保护方案，覆盖全行业。']
                }, {
                    type: '知识产权保护',
                    imgUrl: '/images/pc/v2/home/solutions/zscqbhjjfa.png',
                    pain: ['企业各类型知识产权缺乏有效自动化管理和监控，如产品设计、视觉形象、过程数据、经营数据，囊括商标、专利、域名、商业秘密各种类别等。', '电子文档类知识产权的保护薄弱，包括文档、设计图纸、图像、音频和视频等。侵权泛滥，难于管控。'],
                    solution: ['真相科技知识产权解决方案提供作品权利认定，自动化监测和取证功能。一旦发现侵权，可以高效的对证据进行固化，并协助权利方进行一站式的司法维权。']
                }, {
                    type: '电商',
                    imgUrl: '/images/pc/v2/home/solutions/dsjjfa.png',
                    pain: ['越来越多的企业将网络作为主要的销售渠道。', '自身的销售数据，竞争对手的销售数据，行业的洞察等，日渐成为企业战略决策的重要参考。', '电商领域的知识产权保护面临巨大挑战，商标侵权、假冒伪劣等问题尤为突出。对这些品牌侵权行为，急需有效的维权手段。'],
                    solution: ['客户自身的经营情况分析，以及竞争对手的分析，辅助战略决策。', '电商侵权监测，对线上的假冒伪劣等侵权行为进行全面监控。', '侵权的快速取证和司法渠道服务，提供一站式服务。']
                }, {
                    type: '版权保护',
                    imgUrl: '/images/pc/v2/home/solutions/bqbhjjfa.png',
                    pain: ['各行业的版权保护问题严重，作品盗用和盗版泛滥，给版权主权人造成严重的影响和经济损失。', '维权之路漫漫，维权成本高，也造成权利人的积极性不高。'],
                    solution: ['对作品权利进行认定，确认权利归属。', '对侵权行为的全网自动化监测，使网络侵权行为无处遁形。', '一站式的侵权取证和司法诉讼服务，有效打击侵权，避免经济损失。']
                }, {
                    type: '网络交易保全',
                    imgUrl: '/images/pc/v2/home/solutions/wljybqjjfa.png',
                    pain: ['随着互联网金融和保险行业的迅猛发展，权益凭证、交易过程等数据均以电子数据形式存在。IP360平台以第三方数据保全的方式对关键数据信息进行固化，确保电子数据信息真实有效不可篡改，从而防范和化解金融保险风险，提升消费者信心、维护行业安全与稳定。'],
                    solution: ['网络交易保全解决方案提供以第三方数据保全的方式对关键数据信息进行固化，确保电子数据信息真实有效不可篡改，从而防范和化解金融保险风险，提升消费者信心、维护行业安全与稳定。']
                }, {
                    type: '电子取证',
                    imgUrl: '/images/pc/v2/home/solutions/dzqzjjfa.png',
                    pain: ['网络电子证据易篡改，且易改无痕，没有机制保证其法律有效性。', '网络电子证据易灭失，固定证据难。', '网络环境的开放，发现证据难，全面排查工作量大。', '电子证据跨地域性，异地取证难。'],
                    solution: ['及时固化电子证据，确保电子证据法律有效性。', '电子证据保全在IP360保全系统中，安全可靠。', '全网监测电子证据，实现跨地域的证据排查和取证。']
                }], [{
                    type: '政务协同链',
                    imgUrl: '/images/pc/v2/home/solutions/zwxtl.png',
                    pain: ['政府与机构日常运营中，没有统一的信息互通基础设施，用户账号繁多，信息孤岛现象依然很严重，拉低了整体效率。机构自身或社会大众办理一项事务，往往要跑很多个地方才能最终完成。'],
                    solution: ['真相科技区块链+，从各业务系统底层增加区块链基础设施，并通过用户、数据、流程，三位一体的上链结合。最终实现高安全保障下的信息互通。无论是跨机构还是跨部门协作，有效合理使用数据，流程全程可追溯，历史信息不可篡改。完好体现客观、公正、高效的信息化升级。 ']
                }, {
                    type: '农产品溯源监管链',
                    imgUrl: '/images/pc/v2/home/solutions/ncpyyjgl.png',
                    pain: ['从国家到行业都十分关注农产品溯源，溯源——成为农产品质量安全保障的第一步工作；农产品乱象频发，质量和安全监管存在很多难题，溯源——有助于监督管理。'],
                    solution: ['以区块链技术为基础，构建溯源与监管业务，能够有效的为农产品质量安全保驾护航。抓住“产地溯源”“物流溯源”“消费溯源”三个重要环节，产品信息上链，B2b产地、物流、分销，全程追溯。根据溯源码抽检实现有效监管。定制溯源链数据统计分析，辅助管理决策。']
                }, {
                    type: '新闻版权链',
                    imgUrl: '/images/pc/v2/home/solutions/xwbql.png',
                    pain: ['现有新闻版权业态存在确权难、发现难、取证难、诉讼难、授权难等诸多问题。内容聚合分发，孕育出版权的确权、授权的区块链应用。'],
                    solution: ['真相版权链解决方案，就快速确权，全网监测追踪溯源，自动取证，直通司法，在线授权按需交易等方面都做了充分的业务梳理。对新闻版权、广告精准分发都有很大帮助。 ']
                }, {
                    type: '保险链',
                    imgUrl: '/images/pc/v2/home/solutions/bxl.png',
                    pain: ['保险行业险种繁多，业务互联网化比较成熟，但保险业务周期长，出险后效率要求高。如何保障业务安全客观，合理自证，防范纠纷，并高效的执行成为普遍需求。'],
                    solution: ['真相保险链，将（保单签约）（出险报案）（理赔）（到款核对）整个业务过程上链保全。区块链的智能合约应用，防止非正常篡改，合约条款程序化，结合AI技术触发条件，执行后续程序，以实现业务的智能化处理。提高处理效率的同时，整体业务流程得到客观真实性保障。']
                }, {
                    type: '电子签约',
                    imgUrl: '/images/pc/v2/home/solutions/dzqy.png',
                    pain: ['传统的纸质签约方式，效率低，成本高，过程繁琐，容易造假。', '电子签约的应用充分的解决了传统签约方式的弊端。应用领域几乎覆盖全行业。'],
                    solution: ['真相电子签约平台依托司法联盟链，结合多项客观性应用技术，保证签约主体的真实性，保障签约行为的真实性。保障签约历史防篡改、签约结果不丢失。独特的智能合约技术，完成签约过程管控、内容触达，提高合同执行的效率。助您实现“签控一体化”管理。']
                }]
            ]
        }
    },
    //过期弹窗提示
    errorExpireInfo:{
        err_title1:"消息提示",
        err_1:"非常抱歉，证据已过期，暂不支持查询！",
    },
    //删除弹窗提示
    errorDeleteInfo:{
        err_title1:"消息提示",
        err_1:"非常抱歉，证据已被删除，暂不支持查询！",
    }
}